import React, { useEffect, useId, useRef, useState, useCallback } from "react";
import InputMask from "react-input-mask";
import './input.css';

const InputDefault = ({
  onChange,
  placeholder,
  label,
  value,
  name,
  disabled,
  mask,
  maxLength,
  onBlur,
  error,
  success,
  autoFocus,
  handleKeyDown,
}) => {
  const id = useId();
  const inputRef = useRef(null);

  const [isFocus, setIsFocus] = useState(false);
  const [inputWrapperStyle, setInputWrapperStyle] = useState();
  const [inputStyle, setInputStyle] = useState();
  const [inputLabelStyle, setInputLabelStyle] = useState();

  // Mueve los handlers arriba, con useCallback (notar dependencias)
  const onInputWrapperStyle = useCallback(() => {
    setInputWrapperStyle(`input-wrapper ${disabled ? "disabled" : ""} `);
  }, [disabled]);

  const onInputLabelStyle = useCallback(() => {
    setInputLabelStyle(
      `poppins-regular-font ${value || isFocus ? "input-label-focused" : ""}`
    );
  }, [value, isFocus]);

  const onInputStatusStyle = useCallback(() => {
    return ` ${error ? "input-error" : ""} ${value && success ? "input-success" : ""}`;
  }, [error, value, success]);

  const onInputStyle = useCallback(() => {
    setInputStyle(`poppins-regular-font ${onInputStatusStyle()}`);
  }, [onInputStatusStyle]);

  useEffect(() => {
    onInputWrapperStyle();
    onInputLabelStyle();
    onInputStyle();
  }, [
    value,
    error,
    success,
    disabled,
    isFocus,
    onInputWrapperStyle,
    onInputLabelStyle,
    onInputStyle
  ]);

  useEffect(() => {
    document.addEventListener("click", (event) => {
      setIsFocus(event?.target === inputRef.current);
    });
    return () => {
      document.removeEventListener("click", () => { });
    };
  }, []);

  return (
    <div className={inputWrapperStyle}>
      {label && (
        <label htmlFor={id} className={inputLabelStyle}>
          {label}
        </label>
      )}

      {mask ? (
        <InputMask
          mask={mask}
          id={id}
          name={name}
          ref={inputRef}
          className={inputStyle}
          value={value}
          onChange={(onValue) => onChange(onValue.target.value)}
          onBlur={onBlur}
          disabled={disabled}
          placeholder={placeholder}
          autoFocus={autoFocus}
        />
      ) : (
        <input
          id={id}
          name={name}
          ref={inputRef}
          className={inputStyle}
          value={value}
          onChange={(onValue) => onChange(onValue.target.value)}
          maxLength={maxLength || 100}
          onBlur={onBlur}
          disabled={disabled}
          placeholder={placeholder}
          autoFocus={autoFocus}
          onKeyDown={handleKeyDown}
        />
      )}
    </div>
  );
};

export default InputDefault;
